import { EpisodeDetailsFragment } from '@funtech-int/kp-graphql-sdk/clients/player-sdk/model/episodeDetails/EpisodeDetails.graphql';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useCurrentEpisode(contentId: string): EpisodeDetailsFragment | undefined {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename !== 'Episode') {
        return undefined;
    }

    return data.content as EpisodeDetailsFragment;
}
